import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { callHistoryRowKey, callRecordKeyDates, rowIsFocusable } from 'flow/components/call-history-v2/call-history-rows';
import DateGroupedList from 'flow/components/call-history-v2/DateGroupedList';
import HistoryCallRecordItem from './call-record/HistoryCallRecordItem';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The finished calls of a queue by date, as one Tab stop. No call's page is
 * open while the list shows, so Tab enters at the first call until a call has
 * had focus.
 */
var QueueHistoryList = function QueueHistoryList(_ref) {
  var callRecordKeysByDate = _ref.callRecordKeysByDate,
    queueKey = _ref.queueKey;
  var dates = useMemo(function () {
    return callRecordKeyDates(callRecordKeysByDate);
  }, [callRecordKeysByDate]);

  // A row's own control is its link to the call.
  var renderRow = function renderRow(row, rowProps) {
    return /*#__PURE__*/_jsx(HistoryCallRecordItem, _objectSpread({
      callRecordKey: row.callRecordKey,
      queueKey: queueKey
    }, rowProps));
  };
  return /*#__PURE__*/_jsx(DateGroupedList, {
    dates: dates,
    rowKey: callHistoryRowKey,
    rowIsFocusable: rowIsFocusable,
    renderRow: renderRow
  });
};

// The section around the list renders again as it loads more; the list does
// not, while its calls are the same.
export default /*#__PURE__*/React.memo(QueueHistoryList);